import { defineComponent, markRaw, computed, openBlock, createElementBlock, normalizeClass, unref, createVNode, createElementVNode, toDisplayString, createCommentVNode, createBlock, resolveDynamicComponent } from "vue";
import Avatar from "../avatar/Avatar.vue.js";
import Badge from "../badge/Badge.vue.js";
const _hoisted_1 = { class: "profile-dropdown-item__info" };
const _hoisted_2 = { class: "profile-dropdown-item__name" };
const _hoisted_3 = {
  key: 0,
  class: "profile-dropdown-item__description"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProfileDropdownItem",
  props: {
    item: {},
    isActive: { type: Boolean, default: false },
    valueKey: { default: "id" },
    labelKey: { default: "name" },
    avatarKey: { default: "avatar" },
    descKey: { default: "description" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const ActiveBadge = markRaw(Badge);
    const getValue = (obj, key) => {
      return obj?.[key];
    };
    const handleClick = () => {
      emit("click", props.item);
    };
    const hasAvatar = computed(() => {
      const avatarValue = getValue(props.item, props.avatarKey);
      return !!avatarValue;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: "button",
        class: normalizeClass(["profile-dropdown-item", {
          "profile-dropdown-item--active": __props.isActive,
          "profile-dropdown-item--no-avatar": !unref(hasAvatar)
        }]),
        onClick: handleClick
      }, [
        createVNode(Avatar, {
          size: "sm",
          "avatar-url": getValue(__props.item, __props.avatarKey),
          title: getValue(__props.item, __props.labelKey),
          "show-titles": false
        }, null, 8, ["avatar-url", "title"]),
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, toDisplayString(getValue(__props.item, __props.labelKey)), 1),
          getValue(__props.item, __props.descKey) ? (openBlock(), createElementBlock("div", _hoisted_3, toDisplayString(getValue(__props.item, __props.descKey)), 1)) : createCommentVNode("", true)
        ]),
        __props.isActive ? (openBlock(), createBlock(resolveDynamicComponent(unref(ActiveBadge)), {
          key: 0,
          class: "profile-dropdown-item__badge",
          variant: "green",
          size: "sm",
          label: "Active"
        })) : createCommentVNode("", true)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProfileDropdownItem.vue2.js.map
